import { render, staticRenderFns } from "./Openbox.vue?vue&type=template&id=6e24d538&scoped=true&"
import script from "./Openbox.vue?vue&type=script&lang=js&"
export * from "./Openbox.vue?vue&type=script&lang=js&"
import style0 from "./Openbox.vue?vue&type=style&index=0&id=6e24d538&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e24d538",
  null
  
)

export default component.exports